import StoreUtil from '@/store/StoreUtil'

export default {
  SET_USER: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'setUser'),
  SET_FETCHING_USER_STATUS: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setFetchingUserStatus'
  ),
  SET_FORGOT_PASSWORD_EMAIL: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setForgotPasswordEmail'
  ),
  SET_USER_PROFILE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setUserProfile'
  ),
  SET_PAYMENT_METHOD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setPaymentMethod'
  ),
  SET_EXCLUDED_SKILL_COUNT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setExcludedSkillCount'
  ),
  INCREMENT_EXCLUDED_SKILL_COUNT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setExcludedSkillCount'
  ),
  DECREMENT_EXCLUDED_SKILL_COUNT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'setExcludedSkillCount'
  ),
  SET_ACTING_AS_CLIENT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'actingAsClient'
  ),
}
